module.exports = "/_next/static/images/server-43de1cb9cad36ffc7cd2104c40afea25.png";